import { Button } from "@tblabs/truffle";
import { XButton } from "./XButton";


export class XPrimaryButton extends XButton
{
    constructor(text: string, icon: string, onClick?: (btn: Button) => void)
    {
        super("primary", text, icon, onClick);
    }
}

export class XSecondaryButton extends XButton
{
    constructor(text: string, icon: string, onClick?: (btn: Button) => void)
    {
        super("dark", text, icon, onClick);
    }
}

export class DefaultButton extends XButton
{
    constructor(text: string, icon: string, onClick?: (btn: Button) => void)
    {
        super("default", text, icon, onClick);
    }
}
